/// <reference path='../../../../typings/index.d.ts' />
/// <reference path='../../components/baseclasses/guid.ts' />
/// <reference path='../../components/models/meevo.model.custom.ts' />

module Meevo.Plugins.EmployeeTemplates {
    'use strict';

    export class EmployeeTemplatesContext extends Meevo.Components.BaseClasses.DataMaintenanceContextBase {

        constructor(appSettings: Meevo.Components.Common.IAppSettings,
            dataService: Meevo.Components.BaseClasses.IDataService,
            modalService: Meevo.Components.Modal.IModalService,
            identityService: Meevo.Components.Common.IIdentityService,
            loggingService: Meevo.Components.Logging.ILoggingService,
            securityChecker: Meevo.Components.Common.ISecurityService,
            trackingService: Meevo.Components.Tracking.ITrackingService) {

            super(appSettings, dataService, modalService, identityService, loggingService, securityChecker, trackingService);
        }

        initializeContext(): void {
            this.entityType = 'EmployeeTemplate';
            this.baseEndpoint = this.appSettings.API_ENDPOINTS.employeeTemplate;
            this.sectionTemplatePath = 'app/plugins/employeeTemplates/sectionViews/';
        }

        initializeSections(): void {
            this.initializeContext();
            if (this.securityChecker.hasSecurityDenyOrGrant(this.securityKeys.DATA_EMPLOYEETEMPLATE_TAB_MAIN + Meevo.Components.Common.SecurityParts.KEY_PART_READ))
                this.sections.push(new MainSection(0,
                    'SECTION_SERVICES_MAIN',
                    'main.html',
                    true,
                    false,
                    this.baseEndpoint,
                    '',
                    this.loggingService,
                    this.dataService,
                    this.identityService,
                    Meevo.Model.NounEnum.EmployeeTemplateMain, null, this.securityKeys.DATA_EMPLOYEETEMPLATE_TAB_MAIN + Meevo.Components.Common.SecurityParts.KEY_PART_READ));
            if (this.securityChecker.hasSecurityDenyOrGrant(this.securityKeys.DATA_EMPLOYEETEMPLATE_TAB_LOCATIONS + Meevo.Components.Common.SecurityParts.KEY_PART_READ))
                this.sections.push(new LocationSection(1,
                    'SECTION_EMPLOYEE_LOCATIONS',
                    'locations.html',
                    false,
                    false,
                    '',
                    'security',
                    this.loggingService,
                    this.dataService,
                    null,
                    Meevo.Model.NounEnum.EmployeeTemplateSecurity,
                    null,
                    this.securityKeys.DATA_EMPLOYEETEMPLATE_TAB_LOCATIONS + Meevo.Components.Common.SecurityParts.KEY_PART_READ));
            if (this.securityChecker.hasSecurityDenyOrGrant(this.securityKeys.DATA_EMPLOYEETEMPLATE_TAB_SERVICES + Meevo.Components.Common.SecurityParts.KEY_PART_READ))
                this.sections.push(new TemplateServiceSection(2,
                    'SECTION_EMPLOYEE_SERVICES',
                    'services.html',
                    true,
                    false,
                    '',
                    '',
                    this.loggingService,
                    this.dataService,
                    this.identityService,
                    Meevo.Model.NounEnum.EmployeeTemplateServices,
                    this.appSettings,
                    this.securityKeys.DATA_EMPLOYEETEMPLATE_TAB_SERVICES + Meevo.Components.Common.SecurityParts.KEY_PART_READ,
                    this.securityChecker));
            if (this.securityChecker.hasSecurityDenyOrGrant(this.securityKeys.DATA_EMPLOYEETEMPLATE_TAB_PAYROLL + Meevo.Components.Common.SecurityParts.KEY_PART_READ))
                this.sections.push(new CompensationSection(3,
                    'SECTION_EMPLOYEE_COMPENSATION',
                    'compensation.html',
                    false,
                    false,
                    '',
                    'compensation',
                    this.loggingService,
                    this.dataService,
                    this.identityService,
                    Model.NounEnum.EmployeeTemplateCompensation,
                    this.modalService,
                    this.securityKeys.DATA_EMPLOYEETEMPLATE_TAB_PAYROLL + Meevo.Components.Common.SecurityParts.KEY_PART_READ
                ));

            if (this.securityChecker.hasSecurityDenyOrGrant(this.securityKeys.DATA_EMPLOYEETEMPLATE_TAB_DEDUCTION + Meevo.Components.Common.SecurityParts.KEY_PART_READ) && !this.identityService.inCentralOfficeMode())
                this.sections.push(new DeductionSection(4,
                    'SECTION_EMPLOYEE_DEDUCTION',
                    'deduction.html',
                    false,
                    false,
                    '',
                    'deduction',
                    this.loggingService,
                    this.dataService,
                    this.identityService,
                    Model.NounEnum.EmployeeTemplateDeductions,
                    null,
                    this.securityKeys.DATA_EMPLOYEETEMPLATE_TAB_DEDUCTION + Meevo.Components.Common.SecurityParts.KEY_PART_READ));

            if (this.securityChecker.hasSecurityDenyOrGrant(this.securityKeys.DATA_EMPLOYEETEMPLATE_TAB_SERVICECOMMISSIONS + Meevo.Components.Common.SecurityParts.KEY_PART_READ) && !this.identityService.inCentralOfficeMode())
                this.sections.push(new ServiceCommissionsSection(5,
                    "SECTION_EMPLOYEE_SERVICE_COMMISSIONS_OVERRIDE",
                    "servicesCommissions.html",
                    false,
                    false,
                    this.baseEndpoint,
                    "",
                    this.loggingService,
                    this.dataService,
                    this.identityService,
                    Meevo.Model.NounEnum.EmployeeTemplateCommissionOverrides,
                    null,
                    this.securityKeys.DATA_EMPLOYEETEMPLATE_TAB_SERVICECOMMISSIONS + Meevo.Components.Common.SecurityParts.KEY_PART_READ));
        }

        selectSection(item): void {
            switch (item.sectionId) {
                case 1:
                    this.buildCrudSecurityKeysBase(this.securityKeys.DATA_EMPLOYEETEMPLATE_TAB_LOCATIONS);
                    break;
                case 2:
                    this.buildCrudSecurityKeysBase(this.securityKeys.DATA_EMPLOYEETEMPLATE_TAB_SERVICES);
                    break;
                case 3:
                    this.buildCrudSecurityKeysBase(this.securityKeys.DATA_EMPLOYEETEMPLATE_TAB_PAYROLL);
                    break;
                case 4:
                    this.buildCrudSecurityKeysBase(this.securityKeys.DATA_EMPLOYEETEMPLATE_TAB_DEDUCTION);
                    break;
                case 5:
                    this.buildCrudSecurityKeysBase(this.securityKeys.DATA_EMPLOYEETEMPLATE_TAB_SERVICECOMMISSIONS);
                    break;
                default:
                    this.buildCrudSecurityKeys(this.securityKeys.DATA_EMPLOYEETEMPLATE_TAB_MAIN);
                    break;
            }
            super.selectSection(item);
        }

        get allowTakeOwnership(): boolean {
            return false;
        }
        initializeHeader(model: any): void {
            this.headerContent = model.displayName;
            this.businessTypeDetail = model.businessTypeDetail;
        }

        // Security Role Management

        get isSecurityRoleRequired(): boolean {
            var empTemplate = this.castModel<Model.EmployeeTemplate>();
            return empTemplate !== undefined || empTemplate.template.securityRoles.length === 0;
        }

        // Category Management

        get isCategoryRequired(): boolean {
            var empTemplate = this.castModel<Model.EmployeeTemplate>();
            return Model.Guard.isSomething(empTemplate)
                && Model.Guard.isSomething(empTemplate.employeeCategories)
                && empTemplate.employeeCategories.length === 0;
        }

        get checkIsOwning(): boolean {
            return (this.locationId === this.homeLocationId);
        }

        addEmployeeCategotry(): void {
            var empTemplate = this.castModel<Model.EmployeeTemplate>();
            if (empTemplate === undefined)
                return;
            if (empTemplate.employeeCategoryDetail !== undefined
                && _.find(empTemplate.employeeCategories, (ec) =>
                { return ec.displayName === empTemplate.employeeCategoryDetail.displayName }) === undefined) {
                {
                    empTemplate.employeeCategories.push(empTemplate.employeeCategoryDetail);
                    empTemplate.employeeCategoryDetail = undefined;
                }
            }
        }

        removeEmployeeCategory(index: number): void {
            var empTemplate = this.castModel<Model.EmployeeTemplate>();
            if (empTemplate === undefined)
                return;
            empTemplate.employeeCategories.splice(index, 1);
        }

        get showDelete(): boolean {
            return this.selectedSection.sectionId === 0 //SECTION_SERVICES_MAIN
                && super.showDeleteLogic();
        }

        get showCopy(): boolean {
            return this.selectedSection.sectionId === 0 //SECTION_SERVICES_MAIN
                && super.showCopyLogic();
        }

        postCopy(): void {
            super.postCopy();
            let model = this.castModel<Model.EmployeeTemplate>();
            model.displayName = undefined;
           // model.employeeCategories = [];
           // model.employeeCategoryDetail = undefined;
            model.copyFromTemplateId = this.itemId;
        }

        save(): angular.IPromise<any> {
            let model = this.castModel<Model.EmployeeTemplate>();
            var that;
            that = this.sections[0];
            if ((this.selectedSection.sectionId === 0) && Model.Guard.isSomething(that.backup)) {
                    let previousServicePriceLevel = that.backup.defaultServicePriceLevel;
                    if (previousServicePriceLevel !== model.defaultServicePriceLevel) {
                        this.modalService.alert("MESSAGE_MODAL_EMPLOYEE_PRICE_LEVELS_CHANGED", Meevo.Components.Modal.ModalTranslationModes.Translate, false, { showCancelButton: true, cancelButtonContentKey: 'LABEL_NO', cancelButtonHotKey: 'MODAL_NO_BUTTON', okButtonHotKey: 'MODAL_YES_BUTTON', okButtonContentKey: 'LABEL_YES' })
                            .then((response: boolean) => {
                                if (response) {
                                    model.changeAllServicePriceLevel = true;
                                    return super.save();
                                }
                            }).then(() => {
                                model.changeAllServicePriceLevel = false;
                            }).finally(() => super.save());
                    }
                    else
                        return super.save();
            }
            else if (this.selectedSection.sectionId === 1) {
                var securityRoles: any;
                if (Model.Guard.isSomething(this.selectedSection.model))
                    securityRoles  = this.selectedSection.model['securityRoles'];
                if (Model.Guard.isSomething(securityRoles) && securityRoles.length > 0) {
                    return super.save();
                } else {
                    this.modalService.confirm("MESSAGE_CONFIRM_NO_SECURITYROLE_ASSIGNED", Meevo.Components.Modal.ModalTranslationModes.Translate)
                            .then((response: boolean) => {
                                if (response) {
                                    return super.save();
                                }
                            }).catch((res: any | boolean) => {
                                if (res === false) {
                                    return;
                                }
                            });
                    } 
            }            
            else
                return super.save();
        }
    }
}